// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VT4V","inner":"styles_inner__3c4uA","right":"styles_right__1GdBG","close":"styles_close__3dHK4","footer":"styles_footer__3Yva_"};